import React, { useState, createContext } from "react";

export const InputContext = createContext();

export const InputProvider = ({ children }) => {
  const [inputs, setInputs] = useState({
    memberInfo: {
      inReceipt: "",
      hasLeft: "",
      isMcCloudEligible: "",
      legacyScheme: "",
      dateOfBirth: "",
      dateJoinedScheme: "",
      salaryCurrent: "",
      salaryApril2015: "",
      salaryPostPartRet: "",
      dateOfPartRet: "", //new Date(new Date().setDate(1)).toISOString().split('T')[0],
      dateOfFullRet: "", //we will set it whenever the partial retirement date input changes, or whenever we change the full retirement date on the results page.
      partTimeServicePrePartRet: [],
      partTimeServicePostPartRet: "",
    },
    projectionSettings: {
      cpi: "0.02",
      salaryIncreases: "0.02",
      asAtDate: new Date(new Date().setDate(1)).toISOString().split('T')[0],
      realNominalSwitch: "real",
      equaliseLumpSumsSwitch: "unequal",
      legacyProportionClaimedPartRet: "1",
      reformProportionClaimedPartRet: "0",
      legacyLumpSumPartRet: "0",
      reformLumpSumPartRet: "0",
      legacyLumpSumFullRet: "0",
      reformLumpSumFullRet: "0",
    },
  });

  const updateInput = (group, name, value) => {
    setInputs((prevInputs) => ({
      ...prevInputs,
      [group]: {
        ...prevInputs[group],
        [name]: value,
      },
    }));
  };

  return (
    <InputContext.Provider value={{ inputs, updateInput }}>
      {children}
    </InputContext.Provider>
  );
};
